function _toConsumableArray(arr) {return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();}function _nonIterableSpread() {throw new TypeError("Invalid attempt to spread non-iterable instance");}function _iterableToArray(iter) {if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);}function _arrayWithoutHoles(arr) {if (Array.isArray(arr)) {for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {arr2[i] = arr[i];}return arr2;}}import RestrictedInput from "restricted-input";
import valid from 'card-validator';

var defaultPattern = '{{9999}} {{9999}} {{9999}} {{9999999}}';
var cleanCardNumber = function cleanCardNumber() {var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';return s.replace(/\D/g, '');};

angular.module('gplans.store').
directive('inputPaymentNumber', function () {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function link(scope, elm, attrs, ctrl) {
      if (!ctrl.$options.$$options.debounce || ctrl.$options.$$options.debounce < 50) {
        ctrl.$options.$$options.debounce = 50;
      }

      elm.on('paste', onPaste);

      var instance = new RestrictedInput({
        element: elm[0],
        pattern: defaultPattern });

      instance.__pattern = defaultPattern;

      ctrl.$parsers.unshift(function (value) {
        value = cleanCardNumber(elm.val());
        // console.log('cardNumber $parsers',value);
        updatePattern(value);
        return value;
      });

      ctrl.$formatters.unshift(function (modelValue) {
        // console.log('cardNumber $parsers',value);
        updatePattern(modelValue);
        return format(modelValue);
      });

      ctrl.$validators.cardNumber = function (modelValue, viewValue) {
        // console.log('cardNumber $validators', modelValue, viewValue);
        ctrl._meta = valid.number(modelValue);
        return ctrl._meta.isValid;
      };


      function onPaste(e) {
        var data = function () {
          try {
            var clipboardData = e.originalEvent.clipboardData || window.clipboardData;
            return clipboardData.getData('Text');
          } catch (e) {
            console.warn('failed to update pattern before paste');
            return '';
          }
        }();
        updatePattern(data);
      }

      function updatePattern(value) {
        if (!value) {
          ctrl._meta = null;
          instance.setPattern(defaultPattern);
          instance.__pattern = defaultPattern;
          return false;
        }
        var validateResult = ctrl._meta = valid.number(value);
        var newPattern = getCardNumberPattern(value, validateResult);
        if (newPattern && newPattern !== instance.__pattern) {
          // console.log('new pattern', newPattern);
          instance.setPattern(newPattern);
          instance.__pattern = newPattern;
        }
      }

      function format(value) {
        return instance.strategy.formatter.format({
          value: value,
          selection: { start: 0, end: 0 } }).
        value;
      }


      return function () {
        // unwatchViewValue();
        elm.off('paste', onPaste);
      };

    } };

}).


directive('inputPaymentExpiry', function () {
  return {
    require: 'ngModel',
    link: function link(scope, elm, attrs, ctrl) {

      if (!ctrl.$options.$$options.debounce || ctrl.$options.$$options.debounce < 50) {
        ctrl.$options.$$options.debounce = 50;
      }

      new RestrictedInput({
        element: elm[0],
        pattern: '{{12}} / {{9999}}' });


      ctrl.$validators.cardExpire = function (modelValue, viewValue) {
        var maxElapsedYear = 20;
        ctrl._meta = valid.expirationDate(modelValue, maxElapsedYear);
        return ctrl._meta.isValid;
      };

    } };

}).


directive('inputPaymentCvv', function () {
  return {
    require: 'ngModel',
    scope: {
      cvvMaxLength: '<' },

    link: function link(scope, elm, attrs, ctrl) {

      if (!ctrl.$options.$$options.debounce || ctrl.$options.$$options.debounce < 50) {
        ctrl.$options.$$options.debounce = 50;
      }

      var defaultPattern = '{{9999}}';
      var defaultMaxLength = 4;

      var maxLength = defaultMaxLength;
      attrs.$set('max-length', maxLength);
      var instance = new RestrictedInput({
        element: elm[0],
        pattern: defaultPattern });

      instance.__pattern = defaultPattern;

      ctrl.$validators.cardCvv = function (modelValue, viewValue) {
        ctrl._meta = valid.cvv(modelValue, maxLength);
        return ctrl._meta.isValid;
      };

      ctrl.$parsers.push(function (value) {
        var domValue = elm.val();
        if (!domValue) return value;
        return domValue;
      });

      return scope.$watch('cvvMaxLength', function () {var newMaxLength = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultMaxLength;
        // console.warn('cvvMaxLength updated',newMaxLength)
        if (maxLength !== newMaxLength) {
          maxLength = newMaxLength;
          attrs.$set('max-length', newMaxLength);
          var newPattern = "{{".concat(new Array(newMaxLength).fill('9').join(''), "}}");
          instance.__pattern = newPattern;
          instance.setPattern(newPattern);
        }
        var val = elm.val();
        ctrl.$setViewValue(val);
        ctrl.$validate();
      });
    } };

});



function getCardNumberPattern(cardNumber, _ref) {var card = _ref.card,isPotentiallyValid = _ref.isPotentiallyValid;

  if (!cardNumber || !card) return defaultPattern;

  // console.log('isPotentiallyValid',isPotentiallyValid);
  var targetLength = isPotentiallyValid ?
  Math.max.apply(Math, _toConsumableArray(card.lengths)) :
  card.lengths.find(function (l) {return l > cardNumber;});
  var offsets = [0].concat(card.gaps).concat([targetLength]);
  var components = [];

  for (var i = 0; offsets[i] < targetLength; i++) {
    var start = offsets[i];
    var end = Math.min(offsets[i + 1], targetLength);
    var patternFragment = new Array(end - start).fill('9').join('');
    components.push("{{".concat(patternFragment, "}}"));
  }

  return components.join(' ');
}